import React from 'react';
import PropTypes from 'prop-types';
import Column from 'components/column';
import {isActive} from 'utils/interaction-util';
import {getColumnHeight, getColumnY} from 'utils/layout-util';
import styles from './index.css';

export default class ClusteredColumnSeries extends React.Component {
  static propTypes = {
    activeIndex: PropTypes.number,
    columnSpacing: PropTypes.number,
    data: PropTypes.array,
    index: PropTypes.number,
    interactive: PropTypes.bool,
    numSeries: PropTypes.number,
    scaleY: PropTypes.func,
    style: PropTypes.object,
    tickWidth: PropTypes.number,
    transform: PropTypes.string,
    zeroY: PropTypes.number,
  };

  static defaultProps = {
    activeIndex: -1,
    columnSpacing: 2,
    data: [],
    index: -1,
    interactive: true,
    numSeries: 0,
    scaleY: () => {},
    style: {},
    tickWidth: 0,
    transform: '',
    zeroY: 0,
  };

  getColumnWidth(tickWidth, numSeries, columnSpacing) {
    return Math.floor((tickWidth - columnSpacing) / numSeries);
  }

  getColumnX(tickWidth, index, columnWidth, seriesIndex, columnSpacing) {
    return Math.round(
      tickWidth * index +
        columnWidth * seriesIndex +
        columnSpacing / 2 -
        columnWidth / 2,
    );
  }

  render() {
    const {
      activeIndex,
      columnSpacing,
      data,
      interactive,
      numSeries,
      scaleY,
      style,
      transform,
      tickWidth,
      zeroY,
    } = this.props;
    return (
      <g
        className={styles.ClusteredColumnSeries}
        style={style}
        transform={transform}>
        {data.map((datum, index) => {
          const active = isActive(activeIndex, index, interactive);
          const height = getColumnHeight(zeroY, scaleY, datum.value);
          const width = this.getColumnWidth(
            tickWidth,
            numSeries,
            columnSpacing,
          );
          const x = this.getColumnX(
            tickWidth,
            index,
            width,
            this.props.index,
            columnSpacing,
          );
          const y = getColumnY(scaleY, datum.value);
          return (
            <Column
              active={active}
              className={datum.className}
              height={height}
              key={`column-${index}`}
              style={datum.style || style}
              width={width}
              x={x}
              y={y}
            />
          );
        })}
      </g>
    );
  }
}
